import _ from 'lodash';
import { AnyAction } from 'redux';
import { updateInfoBadgeCountOfSideBarHeader } from 'src/adminPanel/components/sideBar/sideBarMenuItems';
import { ROUTE_ADMIN_SERVICE_REPAIR_ORDER } from 'src/config/routes';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';

import {
    FAILURE_REPAIR_ORDERS,
    REQUEST_REPAIR_ORDERS,
    SUCCESS_FINISH_REPAIR_ORDER,
    SUCCESS_REPAIR_ORDERS,
} from 'src/store/repair-orders/actions';

export function repairOrdersReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_REPAIR_ORDERS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_REPAIR_ORDERS: {
            ROUTE_ADMIN_SERVICE_REPAIR_ORDER.infoBadgeCount = action.response.data.length || 0;
            updateInfoBadgeCountOfSideBarHeader();
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        }
        case SUCCESS_FINISH_REPAIR_ORDER:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_REPAIR_ORDERS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}
